// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginForm from './login/LoginForm.js';
import SetRoleForm from './login/SetRoleForm.js';
import AuthContextProvider from './AuthContextProvider';
import PrivateRoute from './PrivateRoute';
import Home from './Home';
import HeaderAppBar from './HeaderAppBar';
import MOTDList from './motd/MOTDList';
import MOTD from './motd/MOTD.js';
import DefaultMOTD from './motd/DefaultMOTD.js';
import EventList from './event/EventList.js';
import Event from './event/Event.js';
import UploadVideo from './event/UploadVideo.js';
import CreateEvent from './event/CreateEvent.js';
import ScheduledEventList from './scheduledEvent/ScheduledEventList.js';
import ScheduledEventAdminList from './scheduledEvent/ScheduledEventAdminList.js';
import ScheduledEvent from './scheduledEvent/ScheduledEvent.js';
import UserList from './user/UserList.js';
import User from './user/User.js';
import GroupList from './group/GroupList.js';
import Group from './group/Group.js';
import PhotoList from './photo/PhotoList.js';
import UploadPhotos from './photo/UploadPhotos.js';
import TodaysScheduledEventList from './today/TodaysScheduledEventList.js';
import VideoConferenceEvent from './today/VideoConferenceEvent.js';
import BingoEvent from './today/BingoEvent.js';
import VideoEvent from './today/VideoEvent.js';
import SiteList from './site/SiteList.js';
import Site from './site/Site.js';
import SiteAdminList from './siteAdmin/SiteAdminList.js';
import SiteAdmin from './siteAdmin/SiteAdmin.js';
import Usage from './usage/Usage.js';
import ChangeUserDetails from './user/ChangeUserDetails.js';
import { ThemeProvider, createTheme } from "@mui/material/styles";

const itvsTheme = createTheme({
  //Override or create new styles, colors, palettes...
  palette: {
    primary: {
      main: "#196ac4"
    },
    secondary: {
      main: "#24D15F"
    }
  }
});

const App = () => {
  return (
    <ThemeProvider theme={itvsTheme}>
      <Router>
        <AuthContextProvider>
          <HeaderAppBar/>
          <Routes>
            <Route path="/login" element={<LoginForm/>} />
            <Route path="/home" element={<PrivateRoute/>}>
              <Route path="/home" element={<Home/>} />
            </Route>
            <Route path="/" element={<PrivateRoute/>}>
              <Route path="/" element={<Home/>} />
            </Route>

            <Route path="/setRole" element={<PrivateRoute/>}>
              <Route path="/setRole" element={<SetRoleForm/>} />
            </Route>

            <Route path="/motds" element={<PrivateRoute/>}>
              <Route path="/motds" element={<MOTDList/>} />
            </Route>
            <Route path="/createMotd" element={<PrivateRoute/>}>
              <Route path="/createMotd" element={<MOTD/>} />
            </Route>
            <Route path="/motd/:id" element={<PrivateRoute/>}>
              <Route path="/motd/:id" element={<MOTD/>} />
            </Route>
            <Route path="/defaultMotd" element={<PrivateRoute/>}>
              <Route path="/defaultMotd" element={<DefaultMOTD/>} />
            </Route>

            <Route path="/events" element={<PrivateRoute/>}>
              <Route path="/events" element={<EventList/>} />
            </Route>
            <Route path="/event/:id" element={<PrivateRoute/>}>
              <Route path="/event/:id" element={<Event/>} />
            </Route>
            <Route path="/uploadVideo" element={<PrivateRoute/>}>
              <Route path="/uploadVideo" element={<UploadVideo/>} />
            </Route>
            <Route path="/createEvent/:type" element={<PrivateRoute/>}>
              <Route path="/createEvent/:type" element={<CreateEvent/>} />
            </Route>

            <Route path="/scheduledEvents" element={<PrivateRoute/>}>
              <Route path="/scheduledEvents" element={<ScheduledEventList/>} />
            </Route>
            <Route path="/scheduledEvent/:id" element={<PrivateRoute/>}>
              <Route path="/scheduledEvent/:id" element={<ScheduledEvent/>} />
            </Route>
            <Route path="/createScheduledEvent" element={<PrivateRoute/>}>
              <Route path="/createScheduledEvent" element={<ScheduledEvent/>} />
            </Route>
            
            <Route path="/users" element={<PrivateRoute/>}>
              <Route path="/users" element={<UserList/>} />
            </Route>
            <Route path="/user/:id" element={<PrivateRoute/>}>
              <Route path="/user/:id" element={<User/>} />
            </Route>
            <Route path="/createUser" element={<PrivateRoute/>}>
              <Route path="/createUser" element={<User/>} />
            </Route>
            <Route path="/updateUser" element={<PrivateRoute/>}>
              <Route path="/updateUser" element={<ChangeUserDetails/>} />
            </Route>

            <Route path="/groups" element={<PrivateRoute/>}>
              <Route path="/groups" element={<GroupList/>} />
            </Route>
            <Route path="/group/:id" element={<PrivateRoute/>}>
              <Route path="/group/:id" element={<Group/>} />
            </Route>
            <Route path="/createGroup" element={<PrivateRoute/>}>
              <Route path="/createGroup" element={<Group/>} />
            </Route>

            <Route path="/photos" element={<PrivateRoute/>}>
              <Route path="/photos" element={<PhotoList/>} />
            </Route>
            <Route path="/uploadPhotos" element={<PrivateRoute/>}>
              <Route path="/uploadPhotos" element={<UploadPhotos/>} />
            </Route>

            <Route path="/today" element={<PrivateRoute/>}>
              <Route path="/today" element={<TodaysScheduledEventList/>} />
            </Route>
            <Route path="/videoConferenceEvent/:id" element={<PrivateRoute/>}>
              <Route path="/videoConferenceEvent/:id" element={<VideoConferenceEvent/>} />
            </Route>
            <Route path="/bingoEvent/:id" element={<PrivateRoute/>}> 
              <Route path="/bingoEvent/:id" element={<BingoEvent/>} />
            </Route> 
            <Route path="/videoEvent/:id" element={<PrivateRoute/>}>
              <Route path="/videoEvent/:id" element={<VideoEvent/>} />
            </Route>
            <Route path="/sites" element={<PrivateRoute/>}>
              <Route path="/sites" element={<SiteList/>} />
            </Route>
            <Route path="/site/:id" element={<PrivateRoute/>}>
              <Route path="/site/:id" element={<Site/>} />
            </Route>
            <Route path="/createSite" element={<PrivateRoute/>}>
              <Route path="/createSite" element={<Site/>} />
            </Route>

            <Route path="/usage" element={<PrivateRoute/>}>
              <Route path="/usage" element={<Usage/>} />
            </Route>

            <Route path="/siteAdmins" element={<PrivateRoute/>}>
              <Route path="/siteAdmins" element={<SiteAdminList/>} />
            </Route>
            <Route path="/siteAdmin/:id" element={<PrivateRoute/>}>
              <Route path="/siteAdmin/:id" element={<SiteAdmin/>} />
            </Route>
            <Route path="/createSiteAdmin" element={<PrivateRoute/>}>
              <Route path="/createSiteAdmin" element={<SiteAdmin/>} />
            </Route>
            <Route path="/siteEvents" element={<PrivateRoute/>}>
              <Route path="/siteEvents" element={<ScheduledEventAdminList/>} />
            </Route>
          </Routes>
        </AuthContextProvider>
      </Router>
    </ThemeProvider>
  );
};

export default App;
